import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-service-conseiller-peb',
  templateUrl: './service-conseiller-peb.component.html',
  styleUrls: ['./service-conseiller-peb.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceConseillerPebComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
